import './PeriscopeWorkflowRuleCriteria.scss';
import { CodeHighlight } from '@ui/general';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { PeriscopeSfWorkflowRuleMetadata } from '@sonar-software/sonar-ts-types';
import React from 'react';

export interface PeriscopeWorkflowRuleCriteriaProps {
	criteria: PeriscopeSfWorkflowRuleMetadata['criteria'];
	index: number;
	isFormula: boolean;
}

export const PeriscopeWorkflowRuleCriteria: React.FC<PeriscopeWorkflowRuleCriteriaProps> = ({
	criteria = [],
	index,
	isFormula
}) => {
	if (!criteria.length) {
		return null;
	}

	const title = isFormula ? COPY_SPECIFIC.FORMULA : COPY_SPECIFIC.CRITERIA;

	return (
		<div className='workflow-rule-criteria'>
			<b>{ title }</b>
			{ criteria.map((row) =>
				<CodeHighlight
					code={ row.code }
					codeReferences={ row.codeReferences }
					index={ index }
					key={ row.code } />) }
		</div>
	);
};
